const PERF_LOG_PREFIX = "[PTT Perf]";

export type RedirectReason =
  | "already_authenticated"
  | "missing_token"
  | "admin_only_denied"
  | "login_success"
  | "dashboard_default"
  | "unknown";

export function logRoute(path: string, auth: { hasToken: boolean; userId?: number }) {
  console.info(`${PERF_LOG_PREFIX} route`, {
    path,
    authStatus: auth.hasToken ? "authenticated" : "anonymous",
    userId: auth.userId ?? null,
  });
}

export function logRedirect(
  source: string,
  to: string,
  reason: RedirectReason,
  extra?: Record<string, unknown>,
) {
  console.info(`${PERF_LOG_PREFIX} redirect`, {
    source,
    to,
    reason,
    ...extra,
  });
}

export function logSpinner(reason: string, active: boolean) {
  console.info(`${PERF_LOG_PREFIX} spinner`, { reason, active });
}

export function logApiStart(
  method: string,
  url: string,
  requestId: string,
): number {
  const start = performance.now();
  console.info(`${PERF_LOG_PREFIX} api:start`, {
    requestId,
    method: method.toUpperCase(),
    url,
    startMs: Math.round(start),
  });
  return start;
}

export function logApiEnd(
  method: string,
  url: string,
  requestId: string,
  startMark: number,
  status?: number,
  error?: boolean,
) {
  const durationMs = Math.round(performance.now() - startMark);
  const payload = {
    requestId,
    method: method.toUpperCase(),
    url,
    durationMs,
    status: status ?? null,
    slow: durationMs > 3000,
    error: !!error,
  };
  if (durationMs > 3000) {
    console.warn(`${PERF_LOG_PREFIX} api:slow`, payload);
  } else {
    console.info(`${PERF_LOG_PREFIX} api:end`, payload);
  }
}
